import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-hero-section',
  templateUrl: './hero-section.component.html',
  styleUrls: ['./hero-section.component.scss'],
  standalone: false,
})
export class HeroSectionComponent {
  @Input() title = 'Bring Learning to Life';
  @Input() subtitle = 'Fueling Success: Wherever Learning Happens';
  @Input() description = `Empower your teaching with digital tools and resources that provide impactful learning experiences and improve student outcomes, all designed to meet the dynamic needs of educators and learners.`;
}
